import api from "./api";

// ============================
// Get All YouTube Configurations
// ============================
export const getYoutube = async () => {
  const response = await api.get("/youtube");
  return response;
};

// ============================
// Get YouTube By ID
// ============================
export const getYoutubeById = async (id) => {
  const response = await api.get(`/youtube/${id}`);
  return response;
};

// ============================
// Get Complete YouTube Data
// Channel + Videos + Shorts
// ============================
export const getYoutubeData = async () => {
  const response = await api.get("/youtube/data");
  return response;
};

// ============================
// Create YouTube Configuration
// ============================
export const createYoutube = async (data) => {
  const response = await api.post("/youtube", data);
  return response;
};

// ============================
// Update YouTube Configuration
// ============================
export const updateYoutube = async (id, data) => {
  const response = await api.put(`/youtube/${id}`, data);
  return response;
};

// ============================
// Delete YouTube Configuration
// ============================
export const deleteYoutube = async (id) => {
  const response = await api.delete(`/youtube/${id}`);
  return response;
};

// ============================
// Toggle Active Status
// ============================
export const toggleYoutubeStatus = async (id) => {
  const response = await api.patch(
    `/youtube/${id}/status`
  );

  return response;
};

// ============================
// Update Social Links
// ============================
export const updateYoutubeSocialLinks = async (
  id,
  socialLinks
) => {
  const response = await api.patch(
    `/youtube/${id}/social-links`,
    {
      socialLinks,
    }
  );

  return response;
};

// ============================
// Update Content
// ============================
export const updateYoutubeContent = async (
  id,
  content
) => {
  const response = await api.patch(
    `/youtube/${id}/content`,
    {
      content,
    }
  );

  return response;
};

// ============================
// Update Settings
// ============================
export const updateYoutubeSettings = async (
  id,
  settings
) => {
  const response = await api.patch(
    `/youtube/${id}/settings`,
    {
      settings,
    }
  );

  return response;
};